import { render } from "./PnpToolContainer.vue?vue&type=template&id=1474ae36&ts=true"
import script from "./PnpToolContainer.vue?vue&type=script&lang=ts"
export * from "./PnpToolContainer.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/qti-player/qti-player/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__